/**
 * @requires ../node_modules/basiclightbox/dist/basicLightbox.min.js
 */

'use strict';

;( () => {

	// Gravity Forms' bundled Chosen library refuses to enhance selects on
	// mobile user agents, leaving the bare native multiselect listbox behind.
	// It also re-initializes from scratch (via a fresh inline script) on
	// EVERY AJAX re-render of the form — including a failed validation pass
	// — so a one-off fix on modal-open isn't enough; this has to re-run every
	// time GF fires its own `gform_post_render` event.
	function enhanceProductInterestField( formEl ) {
		if ( ! window.jQuery ) return;

		const $select = window.jQuery( formEl ).find( 'select[multiple]' );

		if ( 0 === $select.length ) return;

		if ( 0 === $select.siblings( '.chosen-container' ).length ) {
			if ( 'function' !== typeof $select.chosen ) return; // Chosen hasn't loaded yet.

			const originalUserAgent = window.navigator.userAgent;

			try {
				Object.defineProperty( window.navigator, 'userAgent', {
					value: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64)',
					configurable: true,
				} );

				$select.chosen( { no_results_text: 'No results match' } );
			} finally {
				Object.defineProperty( window.navigator, 'userAgent', {
					value: originalUserAgent,
					configurable: true,
				} );
			}
		}

		$select.trigger( 'chosen:updated' );
	}

	document.addEventListener( 'alpine:init', () => {

		Alpine.data( 'registerModal', () => ({

			lightbox: null,

			init() {
				if ( new URLSearchParams( window.location.search ).has( 'debug_modal' ) ) {
					this.$nextTick( () => this.openModal() );
				}
			},

			openModal( event ) {
				if ( event ) event.preventDefault();

				if ( this.lightbox ) {
					this.lightbox.show();
					return;
				}

				const target = this.$el.dataset.formTarget || 'event-registration-form';
				const formEl = document.getElementById( target );

				if ( ! formEl ) return;

				if ( ! window.basicLightbox || 'function' !== typeof window.basicLightbox.create ) {
					console.error( 'basicLightbox is unavailable.' );
					return;
				}

				formEl.classList.remove( 'hidden' );
				formEl.classList.add( 'theme--light' );
				formEl.style.display = '';

				const wrapperEl = document.createElement( 'div' );
				const closeBtn  = document.createElement( 'button' );

				closeBtn.type      = 'button';
				closeBtn.className = 'close icon icon--close icon--stealth';
				closeBtn.setAttribute( 'aria-label', 'Close' );
				closeBtn.innerHTML = '<span class="sr-only">Close</span>';

				wrapperEl.appendChild( closeBtn );
				wrapperEl.appendChild( formEl );

				[ 'top', 'bottom', 'left', 'right' ].forEach( ( side ) => {
					const line = document.createElement( 'span' );
					line.className = 'modal-border-line modal-border-line--' + side;
					wrapperEl.appendChild( line );
				} );

				const onKeyDown = ( e ) => {
					if ( 'Escape' === e.key && this.lightbox ) this.lightbox.close();
				};

				this.lightbox = window.basicLightbox.create( wrapperEl, {
					className: 'registration-modal',
					onShow: () => {
						document.addEventListener( 'keydown', onKeyDown );
					},
					onClose: () => {
						document.removeEventListener( 'keydown', onKeyDown );
						return true;
					},
				} );

				if ( ! this.lightbox ) {
					console.error( 'Unable to create lightbox instance.' );
					return;
				}

				closeBtn.addEventListener( 'click', () => this.lightbox.close() );

				this.lightbox.show();

				// Chosen's own vendor script may not have finished loading
				// yet at the exact moment the modal first opens. Retry for a
				// few seconds instead of silently giving up.
				let attempts = 0;
				const tryEnhance = () => {
					const select   = formEl.querySelector( 'select[multiple]' );
					const enhanced = select && select.parentElement.querySelector( '.chosen-container' );

					if ( enhanced ) return;

					enhanceProductInterestField( formEl );

					if ( ! formEl.querySelector( '.chosen-container' ) && ++attempts < 30 ) {
						setTimeout( tryEnhance, 100 );
					}
				};
				tryEnhance();

				if ( window.jQuery && ! formEl.dataset.postRenderBound ) {
					formEl.dataset.postRenderBound = 'true';

					// GF fires this on `document`, not on the form itself,
					// after every AJAX re-render (a failed validation pass
					// replaces the field with a fresh, un-enhanced select).
					window.jQuery( document ).on( 'gform_post_render', ( e, formId ) => {
						if ( formEl.id === 'gform_wrapper_' + formId || formEl.querySelector( '#gform_' + formId ) ) {
							enhanceProductInterestField( formEl );
						}
					});
				}
			},

			destroy() {
				if ( this.lightbox && this.lightbox.visible() ) this.lightbox.close();
			},
		}) );
	});
})();
